import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { LOCAL_API_URL } from "../../path";
import { DownloadOutlined } from "@ant-design/icons";

const Piechart2 = ({
  data,
  collegeId,
  BatchYear,
  Shift,
  BranchCode,
}) => {
  const [Chartdata, setChartdata] = useState({
    labels: [],
    colors: [],
    series: [],
  });

  // =========================================================
  // PREPARE PIE CHART DATA
  // =========================================================
  useEffect(() => {
    if (data?.length) {
      const duplicateState = {
        labels: [],
        colors: [],
        series: [],
      };

      data.forEach((item) => {
        duplicateState.labels.push(item?.goal_title);
        duplicateState.colors.push(item?.icon_color);
        duplicateState.series.push(item?.user_count);
      });

      setChartdata(duplicateState);
    } else {
      setChartdata({
        labels: [],
        colors: [],
        series: [],
      });
    }
  }, [data]);

  // =========================================================
  // DOWNLOAD JOURNAL DETAILS CSV
  // =========================================================
  const handleDownloadCSV = async () => {
    try {
      const payload = {
        selected_college_id: collegeId,

        ...(BatchYear?.length > 0 && {
          batch_year: BatchYear.map(Number),
        }),

        ...(Shift?.length > 0 && {
          shift: Shift,
        }),

        ...(BranchCode?.length > 0 && {
          branch_code: BranchCode,
        }),
      };

      console.log("Journal CSV payload:", payload);

      const response = await fetch(
        `${LOCAL_API_URL}college/dashboard/top_students/export_journal_details`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `bearer ${localStorage.getItem("SDG_TOKEN")}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error("Journal CSV export failed");
      }

      // Backend directly returns CSV
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");

      link.href = url;
      link.download = "journal_details.csv";

      document.body.appendChild(link);

      link.click();

      link.remove();

      window.URL.revokeObjectURL(url);

      console.log("Journal CSV downloaded successfully");
    } catch (error) {
      console.error("Journal CSV export error:", error);
    }
  };

  // =========================================================
  // PIE CHART OPTIONS
  // =========================================================
  const options = {
    chart: {
      type: "pie",
    },

    labels: Chartdata?.labels || [],

    colors: Chartdata?.colors || [],

    tooltip: {
      y: {
        formatter: function (value, opts) {
          return (
            data?.[opts?.seriesIndex]?.percent ||
            value
          );
        },
      },
    },

    dataLabels: {
      enabled: true,

      formatter: function (val, opts) {
        return (
          data?.[opts?.seriesIndex]?.percent ||
          val
        );
      },
    },

    legend: {
      position: "right",

      width: 320,

      formatter: function (seriesName, opts) {
        return `${seriesName} - ${
          opts?.w?.config?.series?.[opts?.seriesIndex] || 0
        }`;
      },
    },

    responsive: [
      {
        breakpoint: 1200,

        options: {
          chart: {
            width: 650,
          },

          legend: {
            width: 280,
          },
        },
      },

      {
        breakpoint: 900,

        options: {
          chart: {
            width: 600,
          },

          legend: {
            position: "bottom",
            width: undefined,
          },
        },
      },

      {
        breakpoint: 600,

        options: {
          chart: {
            width: 400,
          },

          legend: {
            position: "bottom",
            width: undefined,
          },
        },
      },
    ],
  };

  // =========================================================
  // RENDER
  // =========================================================
  if (!data?.length) {
    return null;
  }

  return (
    <div className="relative w-full">

      {/* =====================================================
          DOWNLOAD CSV BUTTON
      ===================================================== */}
      {collegeId && (
        <div className="flex justify-end mb-2 pr-10">
          <button
            type="button"
            onClick={handleDownloadCSV}
            className="px-3 py-2 rounded-md bg-[#1677ff] text-white font-medium text-sm hover:bg-[#0958d9] flex items-center gap-2"
          >
            <DownloadOutlined />
            Journal CSV
          </button>
        </div>
      )}

      {/* =====================================================
          PIE CHART
      ===================================================== */}
      <div className="w-full flex justify-center overflow-visible">
        <Chart
          options={options}
          series={Chartdata?.series || []}
          type="pie"
          width={800}
          height={800}
        />
      </div>

    </div>
  );
};

export default Piechart2;